import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { BmMgmFeeFg, BmMgmFeeGroupForm } from "../../../pojo/bm-form";
import { BmGrandTotalMgmFeeCalcService } from "../total/bm-grand-total-mgm-fee-calc.service";
import { BmGroupTotalCalculationsService } from "../total/bm-group-total-calculations.service";
import { BmCalcHelperService } from "../../general/bm-calc-helper.service";
import { MgmFeeCommitmentFormService } from "../commitment/mgm-fee-commitment-form.service";
import { MgmFeePcntFormService } from "../mgmFee/mgm-fee-pcnt-form.service";
import { PcntOfMgmFeeFormService } from "../mgmFee/pcnt-of-mgm-fee-form.service";
import { BmMgmVatFormService } from "../vat/bm-mgm-vat-form.service";
import { MgmFeeValuesFormService } from "../mgmFee/mgm-fee-values-form.service";
import { CatchUpService } from "../catchUp/catch-up.service";
import { BmMgmFeeGroup } from "../../../pojo/bm-classes";
import { ValidatorNotBlank } from "../../../pojo/bm-const";

export class BmMgmGeneralCalcService {
  /**
   * Create Management fee form for all Section, which contains
   *  - groups array
   *  - groups total values array
   *  - totalRow value
   *
   * @param groups array of mgm fee groups
   * @param yearsNumber number of the years in model
   */
  public static createForm(groups: BmMgmFeeGroup[], yearsNumber: number): FormGroup<BmMgmFeeFg> {
    // Form Array of groups in mgmFeeSection (eg. Group 1, Israeli, Foreigners etc.)
    const sectionGroupsFa = new FormArray(groups.map((group) => this.createMgmFeeGroupForm(group, yearsNumber)));
    // Form Array of total values of all Groups
    const sectionTotalFa = BmGrandTotalMgmFeeCalcService.createGrandTotalMgmForm(yearsNumber);
    // Total row value of the total values Array
    const sectionTotalRowValue = new FormControl<number>(BmCalcHelperService.recalculateRowTotal(sectionTotalFa));

    return new FormGroup<BmMgmFeeFg>({
      groups: sectionGroupsFa,
      total: sectionTotalFa,
      showSection: new FormControl<boolean>(true),
      totalRow: sectionTotalRowValue,
      totalRowPcnt: new FormControl<number>(0),
    });
  }


  public static createMgmFeeGroupForm(group: BmMgmFeeGroup, yearsNumber: number): FormGroup<BmMgmFeeGroupForm> {

    const mgmFeeFormGroup = new FormGroup<BmMgmFeeGroupForm>({
      uuid: new FormControl(group.uuid),
      name: new FormControl(group.name, { validators: [ Validators.required, ValidatorNotBlank] }),
      isRenameMode: new FormControl(false),
      oldName: new FormControl(group.name),
      priority: new FormControl(group.priority),
      showGroup: new FormControl(true),
      subGroups: new FormGroup({
        commitment: MgmFeeCommitmentFormService.createCommitmentForm(group.subGroups.commitment),
        mgmFeesPcnt: MgmFeePcntFormService.createMgmFeePcntForm(group.subGroups.mgmFeesPcnt),
        pcntOfMgmFees: PcntOfMgmFeeFormService.createPcntOfMgmFeeForm(group.subGroups.pcntOfMgmFees),
        vatPcnt: BmMgmVatFormService.createMgmFeeVatPcntForm(group.subGroups.vatPcnt),
        mgmFeeValues: MgmFeeValuesFormService.createMgmFeeValuesForm(yearsNumber),
        vatValues: BmMgmVatFormService.createMgmFeeVatValuesForm(yearsNumber),
        catchUp: CatchUpService.createMgmFeesCatchUpForm(yearsNumber, group.subGroups.isCatchUpSelected),
      }),
      totalRow: new FormControl<number>(0),
      totalRowPcnt: new FormControl<number>(0),
      total: BmGroupTotalCalculationsService.createTotalMgmForm(yearsNumber),
    });

    MgmFeeValuesFormService.mgmFeeValuesRecalculate(mgmFeeFormGroup);
    CatchUpService.catchUpValuesRecalculate(mgmFeeFormGroup);
    BmMgmVatFormService.recalculateVatValues(mgmFeeFormGroup);
    BmGroupTotalCalculationsService.groupTotalRecalculate(mgmFeeFormGroup);

    return mgmFeeFormGroup;
  }
}
